import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HealthSystemRegistrationDTO } from "src/app/signup/model/HealthSystemRegistrationDTO";
import { RequestDemo } from "../../model/v2/healthSystem/request-demo";
import { BaseService } from "../shared/base.service";

@Injectable({
  providedIn: "root",
})
export class HealthSystemService {
  constructor(private baseService: BaseService) {}

  requestDemo(body: RequestDemo): Observable<any> {
    return this.baseService.anonymousPost<any>(
      `HealthSystem/RequestDemo`,
      body
    );
  }

  AddHealthSystemRegistrationRequest(
    signup: HealthSystemRegistrationDTO
  ): Observable<any> {
    return this.baseService.anonymousPost<any>(
      `HealthSystem/HealthSystemRegistrationRequest`,
      signup
    );
  }

  organizationSignup(formData: any): any {
    return this.baseService.anonymousPost<any>(
      `HealthOrganization/AddHealthOrganizationRegistration`,
      formData
    );
  }

  getHealthOrganizationTypes(): Observable<any> {
    return this.baseService.anonymousGet<any>(
      `HealthOrganization/GetHealthOrganizationTypes`
    );
  }

  getHealthOrganizationSubscriptionTypes(): Observable<any> {
    return this.baseService.anonymousGet<any>(
      `HealthOrganization/GetHealthOrganizationSubscriptionTypes`
    );
  }

  ApproveHealthOrgHealthOrganization(id:number, file?: any) {
    const formData = new FormData();
    formData.append("Id", id.toString());

    if (file) {
      formData.append("sasAgreementFile", file);
    }

    return this.baseService.upload<any>(`HealthOrganization/ApproveHealthOrg`, formData);
  }

  UpdateHealthOrganizationRegistration(formData: any): any {
    return this.baseService.anonymousPost<any>(
      `HealthOrganization/UpdateHealthOrganizationRegistration`,
      formData
    );
  }

  RejectNewHealthOrgRequest(temphealthOrgId: number): any {
    return this.baseService.post<any>(
      `HealthOrganization/RejectNewHealthOrgRequest?temphealthOrgId=${temphealthOrgId}`,
      {}
    );
  }

  DeactiveHealthOrg(healthorgId: number): any {
    return this.baseService.post<any>(
      `HealthOrganization/DeactiveHealthOrg?healthorgId=${healthorgId}`,
      {}
    );
  }
}
